import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {BaseModel} from '../../models/base.model';
import {MasterService} from '../../services/master.service';
import {BACKEND_METHOD_CONSTANT} from '../../services/url-constant';

@Component({
  selector: 'lba-select-method',
  templateUrl: './select-method.component.html',
  styleUrls: ['./select-method.component.scss'],
})
export class SelectMethodComponent implements OnInit, OnDestroy {

  searchStr: string = '';

  methods: BaseModel[];

  methodName: string = 'Select method';

  subscription: Subscription;

  isLoaded: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private masterService: MasterService,
  ) {
  }

  ngOnInit() {
    this.subscription = this.masterService.getObjects(BACKEND_METHOD_CONSTANT.method)
      .subscribe((data: BaseModel[]) => {
        this.isLoaded = true;
        this.methods = data;
      },
        error => {
          console.log(error);
          window.alert('Error: ' + error.message + ', error status: ' + error.status);
        });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  closeModal() {
    this.activeModal.close();
  }

  selectMethod(selectedObject: BaseModel) {
    this.activeModal.close(selectedObject);
  }

}
